import { TakeFotoBox } from "components/TakeFotoBox/TakeFotoBox"
import { TakeNoteBox } from "components/TakeNoteBox/TakeNoteBox"
import { File, TestData } from "graphql/types"

type TestSetupProps = {
  data: TestData
  setData: (data: TestData) => void
}

export const Engineering = (props: TestSetupProps) => {
  const { data, setData } = props

  const setImageData = (images: File[]) => {
    setData({
      ...data,
      image: images,
    })
  }

  return (
    <>
      <TakeNoteBox data={data} setData={setData} name="Engineering" />
      <TakeFotoBox
        setImages={setImageData}
        images={data.image}
        imageName="Engineering"
      />
    </>
  )
}
